// extracted by mini-css-extract-plugin
module.exports = {"app":"styles_app__c-xFM","app__content":"styles_app__content__2-tol","active":"styles_active__3n4NX"};